<template>
  <v-cotainer fluid grid-list-md fill-height>
    <v-layout row wrap>
      <!-- <v-flex xs12 sm4 md4 style="visibility: hidden;">
            Barcode Image
            <br>
            <svg id="barcode"></svg>
          </v-flex> -->
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="headline text-xs-center">
            Product Unique Id ( HUID | RFID )
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn outlined @click="addProductSet()">
            <v-icon left color="teal">add</v-icon>
            New Item
          </v-btn>
          <!-- <router-link to="/Dashboard">
            <v-btn icon>
              <v-icon class="white--text">close</v-icon>
            </v-btn>
          </router-link> -->
        </v-toolbar>

        <v-data-table
          :headers="productSetHeader"
          :items="productUniqueIds"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <!-- <td>
              <b>{{ props.item["product"] }}</b>
            </td> -->
            <td>
              <b>{{ props.item["unqId"] }}</b>
            </td>
            <td>
              <b>{{ props.item["barcode"] }}</b>
            </td>
            <td>
              <b>{{ props.item["grossWeight"] }}</b>
            </td>
            <td>
              <b>{{ props.item["purity"] }}</b>
            </td>
            <td>
              <b>{{ props.item["lessStone"] }}</b>
            </td>
            <td>
              <b>{{ props.item["sold"] ?  'Yes' : 'No' }}</b>
            </td>
            <td>
              <v-btn icon class="mx-0" :disabled="props.item.sold || props.item.autoGenerated" @click="edit(props.item)">
                <v-icon color="pink">edit</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0"  @click="printBarcode(props.item)">
                <v-icon color="pink">print</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" :disabled="props.item.sold || props.item.autoGenerated" @click="deleteProductSet(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td> 
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <!-- Start Product Set Dialog -->
    <v-dialog v-model="productSetDialog" persistent max-width="1000px">
      <v-card persistent v-if="currentSet">
        <v-card-title class="primary white--text">
          <span class="headline">Create Product Barcode and HUID</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-select
                  v-model="currentSet.product"
                  :items="productListByBrand"
                  item-text="title"
                  item-value="value"
                  label="Product"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field
                  type="text"
                  v-model="currentSet.unqId"
                  label="Unique ID (HUID|RFID)"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field
                  type="number"
                  v-model.number="currentSet.grossWeight"
                  label="Net Weight"
                  suffix="Gram"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field
                  type="text"
                  label=" Barcode"
                  v-model="currentSet.barcode"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm2 md3>
                <v-btn color="primary" @click="generateBarcode(null)">Generate New Barcode</v-btn>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  type="text"
                  v-model="currentSet.purity"
                  label="Purity"
                  suffix="%"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  type="number"
                  v-model="currentSet.lessStone"
                  label="less"
                  suffix="%"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datePicker"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="currentSet.date"
                    label="Date"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="currentSet.date"
                    @input="datePicker = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" @click="productSetDialog = false" flat
            >Cancel</v-btn
          >
          <v-btn
            color="primary darken-1"
            @click="update()"
            v-if="currentSet['.key']"
            flat
            >Update</v-btn
          >
          <v-btn
            v-else
            color="blue darken-1"
            @click="save()"
            flat
            >Create</v-btn
          >
        </v-card-actions>
      </v-card> 
    </v-dialog>
    <v-flex xs12 sm4 md4 style="visibility: hidden;">
      Barcode Image
      <br>
      <svg id="barcode"></svg>
    </v-flex>
  </v-cotainer>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
const mapBuyerGetters = createNamespacedHelpers("Buyer")["mapGetters"];
import { barcodePrintPDF } from "../../../utils/barcodePrint";
export default {
  data() {
    return {
      datePicker: null,
      productSetDialog: false,
      currentSet: null,
      productSetHeader: [
        { text: "UniqueId", value: "deposit - ID" },
        { text: "Barcode", value: "barcode" },
        { text: "Net Weight", value: "name" },
        { text: "Purity", value: "purity" },
        { text: "less", value: "lessStone" },
        { text: "Sold", value: "name" },
        { text: "Edit", value: "edit" },
        { text: "Print Barcode", value: "edit" },
        { text: "Delete", value: "edit" },
      ],
    };
  },
  created() {
    this.$bindAsArray(
      "products",
      this.$root.$firebaseRefs.products
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    ),
      this.$bindAsArray(
        "productUniqueIds",
        this.$root.$firebaseRefs.productUniqueId
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      );
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear"]),
    ...mapGlobalGetters({ units: "productUnit" }),
    productListByBrand() {
      return this.products
        .filter((item) => {
          return (
            item["brand"] === this.selectedBrand 
          );
        })
        .map((p) => {
          return { title: p.name, value: p[".key"] };
        });
    },
    productSetsByBrand() {
      return this.productSets.filter((item) => {
        return (
          item["brand"] === this.selectedBrand &&
          (item.date
            ? item.date >= this.finYear.start && item.date <= this.finYear.end
            : true)
        );
      });
    },
  },
  watch: {
    "currentSet.barcode": {
      handler(newVal, oldVal) {
        JsBarcode("#barcode", this.currentSet.barcode);
      },
      deep: true
    },
  },
  methods: {
    save() {
      this.currentSet.date = new Date(this.currentSet.date).getTime();
      this.$root.$firebaseRefs.productUniqueId.push(this.currentSet);
      this.productSetDialog = false;
    },
    generateBarcode(barcode){
      if(barcode == null) {
        this.currentSet.barcode = new Date().getTime() + "";
      }
    },
    async printBarcode(item){
      JsBarcode("#barcode", item.barcode);
        await barcodePrintPDF({
          productName : this.productListByBrand.find(i => i['value'] == item.product).title,
          grossWeight : item.grossWeight,
          purity : item.purity,
          lessStone: item.lessStone
      })
    },
    addProductSet() {
      this.currentSet = {
        brand: this.selectedBrand,
        date: new Date().toISOString().substr(0, 10),
        grossWeight: 0,
        purity: 0,
        lessStone: 0,
        unqId: null,
        sold : false,
        product : null,
        barcode:"",
      };
      this.productSetDialog = true;
    },
    edit(productSet) {
      this.currentSet = productSet;
      this.currentSet.date = new Date(this.currentSet.date)
        .toISOString()
        .substr(0, 10);
      this.productSetDialog = true;
    },
    update() {
      this.currentSet.date = new Date(this.currentSet.date).getTime();
      let key = this.currentSet[".key"];
      delete this.currentSet[".key"];
      this.$root.$firebaseRefs.productUniqueId
        .child(key)
        .update(this.currentSet)
        .then((data) => {
          this.currentSet = null;
          this.productSetDialog = false;
        })
        .catch((error) => {
          console.log(error.code, error.message);
        });
    },
    deleteProductSet(productSet) {
      if (window.confirm("Do you want to Delete ?")) {
        this.$root.$firebaseRefs.productUniqueId
          .child(productSet[".key"])
          .remove();
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Settings/ProductUniqueId/ProductUniqueId.vue